import React from 'react'
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";
import OrderDetailsFrameworkAgreement from "./OrderDetailsFrameworkAgreement";
import {FieldArray} from "formik";
import DealingsNavigator from "../../components/DealingsNavigator";
import OrderDetailsPrimaryLot from "./OrderDetailsPrimaryLot";
import OrderDetailsPrimary from "./OrderDetailsPrimary";
import OrderDetailsPartnership from "./OrderDetailsPartnership";
import OrderDetailsPartnershipLot from "./OrderDetailsPartnershipLot";


function OrderDetailsData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);

    const basicDataRefersTo = gVal("form.basicData.refersTo", false);
    const partialOffers = gVal("form.orderObject.partialOffers", false);
    const realizationType = basicDataRefersTo === "Order" ? gVal("form.realizationType.orderRealizationType", false) : (basicDataRefersTo === "FrameworkAgreement" ? gVal("form.realizationType.frameworkRealizationType", false) : null)

    const realization_x_1_1 = (basicDataRefersTo === "Order" && realizationType === "1.1.1") || (basicDataRefersTo === "FrameworkAgreement" && realizationType === "11.1.1");
    const realization_x_1_2 = (basicDataRefersTo === "Order" && realizationType === "1.1.2") || (basicDataRefersTo === "FrameworkAgreement" && realizationType === "11.1.2");
    const realization_x_1_3 = (basicDataRefersTo === "Order" && realizationType === "1.1.3") || (basicDataRefersTo === "FrameworkAgreement" && realizationType === "11.1.3");
    const realization_1_2 = (basicDataRefersTo === "Order" && realizationType === "1.2") || (basicDataRefersTo === "FrameworkAgreement" && realizationType === "11.2");

    const curPrimaryDealingIndex = gVal("primaryDealing", false, -1);
    const curPartnershipDealingIndex = gVal("partnershipDealing", false, -1);

    return (<>

        <Collapse in={basicDataRefersTo === "FrameworkAgreement"} unmountOnExit>
            <OrderDetailsFrameworkAgreement formikProps={formikProps} id={gId("frameworkAgreement")}/>
        </Collapse>

        <Collapse in={realization_x_1_1 || realization_x_1_2 || realization_x_1_3} unmountOnExit>

            <OrderDetailsPrimary
                formikProps={formikProps}
                id={gId("primary")}
                realizationTypeX11={realization_x_1_1}
                realizationTypeX12={realization_x_1_2}
                realizationTypeX13={realization_x_1_3}

            />

            <Collapse in={partialOffers === true} unmountOnExit>
                <FieldArray
                    name={gId("primaryLots")}
                    render={(arrayHelpers) => (<>
                        <DealingsNavigator
                            formikProps={formikProps}
                            id="primaryDealing"
                            items={gVal("form.orderObject.divided", false, [])}
                        />
                        {curPrimaryDealingIndex > -1 &&
                            <OrderDetailsPrimaryLot
                                formikProps={formikProps}
                                id={gId("primaryLots." + curPrimaryDealingIndex)}
                                index={curPrimaryDealingIndex}
                                realizationTypeX11={realization_x_1_1}
                                realizationTypeX12={realization_x_1_2}
                                realizationTypeX13={realization_x_1_3}
                            />
                        }
                    </>)}
                />
            </Collapse>

            <Collapse in={partialOffers === false} unmountOnExit>
                <OrderDetailsPrimaryLot
                    formikProps={formikProps}
                    id={gId("primaryNoLots")}
                    realizationTypeX11={realization_x_1_1}
                    realizationTypeX12={realization_x_1_2}
                    realizationTypeX13={realization_x_1_3}
                />
            </Collapse>
        </Collapse>

        <Collapse in={realization_1_2} unmountOnExit>
            <OrderDetailsPartnership
                formikProps={formikProps}
                id={gId("partnership")}
            />

            <Collapse in={partialOffers === true} unmountOnExit>
                <FieldArray
                    name={gId("partnershipLots")}
                    render={(arrayHelpers) => (<>
                        <DealingsNavigator
                            formikProps={formikProps}
                            id="partnershipDealing"
                            items={gVal("form.orderObject.divided", false, [])}
                        />
                        {curPartnershipDealingIndex > -1 &&
                            <OrderDetailsPartnershipLot
                                formikProps={formikProps}
                                id={gId("partnershipLots." + curPartnershipDealingIndex)}
                                index={curPartnershipDealingIndex}
                            />
                        }
                    </>)}
                />
            </Collapse>
            <Collapse in={partialOffers === false} unmountOnExit>
                <OrderDetailsPartnershipLot
                    formikProps={formikProps}
                    id={gId("partnershipNoLots")}
                />
            </Collapse>


        </Collapse>
    </>)
}

OrderDetailsData.propTypes = {};

export default OrderDetailsData;
